import WithAuthorization from './WithAuthorization';

export default WithAuthorization;
